import { memo } from 'react'
import { Effect, LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

export interface LazyImageProps {
  src: string
  className?: string
  alt?: string
  effect?: string
  style?: Record<string, any>
}

export const LazyImage: React.FC<LazyImageProps> = memo(props => {
  const { src, className, alt, effect = 'blur', style } = props

  return <LazyLoadImage style={style} className={className} alt={alt} effect={effect as Effect} src={src} />
})
